import React from "react";
import { Link } from "@remix-run/react";
import { twMerge } from "tailwind-merge";
import clsx from "clsx";
import { ChevronRight } from "lucide-react";
import { Text4 } from "~/components/typographies/Texts";
import { InterfaceBreadcrumbItem } from "~/types/GlobalInterfaces";
import { GlobalAnimatedLayout } from "../animation/GlobalAnimatedLayout";
interface BreadcrumbProps {
  items: InterfaceBreadcrumbItem[];
}

const BreadcrumbComponent: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <>
      {" "}
      <section className="w-global mx-auto sticky top-[3.5rem] lg:top-[5.5rem] xl:top-[5.5rem] z-20">
        <GlobalAnimatedLayout direction="left" className="w-fit ">
          <nav
            className={twMerge(
              clsx(
                "w-fit px-[1rem] py-[0.4rem] rounded-lg bg-theme-secondary text-black"
              )
            )}
          >
            <ul className={twMerge(clsx("w-full flex items-center"))}>
              {items.map((item, index) => {
                const isLast = index === items.length - 1;

                const labelMd = isLast
                  ? item.label.length > 12
                    ? item.label.substring(0, 5) + "..." + item.label.slice(-16)
                    : item.label
                  : item.label.length > 5
                  ? item.label.substring(0, 5) + "..."
                  : item.label;

                return (
                  <React.Fragment key={index}>
                    {index > 0 && (
                      <li aria-hidden="true">
                        <ChevronRight
                          className={twMerge("px-[0.2rem]")}
                          size={16}
                        />
                      </li>
                    )}
                    <li>
                      {/* LG and above: show full label */}
                      <div className="hidden lg:block">
                        {isLast ? (
                          <Text4 className="font-semibold" text={item.label} />
                        ) : item.path ? (
                          <Link to={item.path}>
                            <Text4
                              className="flex items-center hover:font-semibold"
                              text={item.label}
                            />
                          </Link>
                        ) : (
                          <Text4
                            className="min-w-max typo-theme-base-hover-primary"
                            text={item.label}
                          />
                        )}
                      </div>

                      {/* MD and below: show truncated label */}
                      <div className="block lg:hidden">
                        {isLast ? (
                          <Text4 className="font-semibold" text={labelMd} />
                        ) : item.path ? (
                          <Link to={item.path}>
                            <Text4
                              className="flex items-center hover:font-semibold"
                              text={labelMd}
                            />
                          </Link>
                        ) : (
                          <Text4
                            className="min-w-max typo-theme-base-hover-primary"
                            text={labelMd}
                          />
                        )}
                      </div>
                    </li>
                  </React.Fragment>
                );
              })}
            </ul>
          </nav>
        </GlobalAnimatedLayout>
      </section>
    </>
  );
};

export default BreadcrumbComponent;
